import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useLocation, Outlet } from "react-router-dom";
import Navbar from "./navbar/navbar";
import strings from "../utils/property-file/dashboard.json";
import "./layout.css";
import "./notificationBar/notificationBar.css";
import Ripple from "./button/ripple";
import HourHiveLogo from "../Asset/Images/whiteLogo.svg";
import constants from "../utils/constants";
import LogoutPopup from "./navbar/logoutPopup";
import Modal from "react-bootstrap/Modal";
import api from "../services/api";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import moment from "moment";
import SpinnerButtonMedium from "./button/SpinnerButtonMedium";
import { FetchedCompanyLogoContext } from "./fetchedCompanyLogo";
import Favicon from "react-favicon";
import { AttendanceRequestContext } from "./requestContext";
import Approved_Icon from "../Asset/Images/approved.svg";
import Decline_Icon from "../Asset/Images/decline_icon.svg";

export default function LayoutComponent() {
  let dashboard = false,
    companyProfile = false,
    employeeProfile = false,
    employeeData = false,
    setting = false,
    manageLeave = false,
    requestsAttendance = false,
    broadcast = false,
    markEmployeeAttendance = false;
  const [toggle, setToggle] = useState(false);
  const [sidebar, setSidebar] = useState(false);
  const [notificationToggle, setNotificationToggle] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [approving, setApproving] = useState(false);
  const [notificationIndex, setNotificationIndex] = useState();
  const [declining, setDeclining] = useState(false);
  const [approveType, setApproveType] = useState("");
  const { companyLogo, setCompanyLogo } = useContext(FetchedCompanyLogoContext);
  const { attendanceRequestCount, setAttendanceRequestCount } = useContext(AttendanceRequestContext)

  const fetchCompanyLogoDetails = async () => {
    try {
      const response = await api.fetchCompanyLogo();
      if (response && response.data) {
        const data = JSON.parse(response.data);
        if (response.success) {
          setCompanyLogo(data.companyLogo ? (data.companyLogo != "" ? data.companyLogo : HourHiveLogo) : HourHiveLogo);
        }
        else {
          setCompanyLogo(HourHiveLogo);
        }
      }
    }
    catch (error) {
      setCompanyLogo(HourHiveLogo)
    }
  }

  const fetchRequestCount = async () => {
    try {
      const response = await api.getAttendanceRequestCount();
      if (response.success && response.data) {
        const data = JSON.parse(response.data);
        setAttendanceRequestCount(data.requestCount.count);
      }
      else {
        setAttendanceRequestCount(null);
      }
    }
    catch (error) {
      toast.error(strings.somethingWentWrong)
    }
  }

  const nav = useNavigate();
  const location = useLocation();
  const handleCollapseToggle = () => {
    if (!isCollapsed2) {
      setIsCollapsed2(true);
    }
    setIsCollapsed(!isCollapsed);
  };

  const handleCollapseToggle2 = () => {
    if (!isCollapsed) {
      setIsCollapsed(true);
    }
    setIsCollapsed2(!isCollapsed2);
  };

  function close() {
    setSidebar(false);
    setNotificationToggle(false);
    setToggle(false);
  }
  const [isCollapsed, setIsCollapsed] = useState(true);
  const [isCollapsed2, setIsCollapsed2] = useState(true);
  const [noNotificationMsg, setNoNotificationMsg] = useState("");
  const [otherNotification, setOtherNotification] = useState([]);
  const [leaveNotifications, setLeaveNotifications] = useState([]);
  const [totalCount, setTotalCount] = useState("");
  const [notificationId, setNotificationId] = useState("");
  const [leaveCount, setLeaveCount] = useState();
  const [otherNotificationCount, setOtherNotificationCount] = useState();
  const [refreshNotification, setRefreshNotification] = useState("notification-refresh-button");
  const [show, setShow] = useState(false);
  var approveLeaveData = {}
  const handleClose = () => setShow(false);

  const getNotifications = async () => {
    try {
      const response = await api.getNotifications();
      if (response && response.data) {
        const data = JSON.parse(response.data);
        if (response.success) {
          setLeaveCount(data && data.leaveCount);
          setOtherNotificationCount(data && data.wfhCount);
          setTotalCount(data && data.totalCount);
          const parsedData = data && data.body;
          let leaveArray = [];
          let wfhArray = [];
          parsedData.map((item) => {
            if (item.type == strings.leaveLabel) {
              leaveArray.push(item);
            } else if (item.type != strings.leaveLabel) {
              wfhArray.push(item);
            }
          });
          setLeaveNotifications(leaveArray);
          setOtherNotification(wfhArray);
        } else if (response && response.success === false && response.data) {
          setLeaveCount(0);
          setOtherNotificationCount(0);
          setLeaveNotifications([]);
          setOtherNotification([]);
        } else {
          setNoNotificationMsg(data.body);
        }
        setRefreshNotification("notification-refresh-button");
      }
    } catch (error) {
      toast.error(strings.somethingWentWrongLabel, { toastId: "error6" });
      setRefreshNotification("notification-refresh-button");
    }
  };

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const notificationPermission = async (data) => {
    setDeclining(true);
    try {
      let body
      if (data.approveType) {
        body = {
          Id: data.id,
          state: data.approveType,
          reason: data.reason,
        };
      }
      else {
        body = {
          Id: notificationId ? notificationId : "",
          state: approveType ? approveType : "",
          reason: data.leaveDeclineReason ? data.leaveDeclineReason : "",
        };
      }

      let response = await api.notificationPermission(body);
      if (response && response.data) {
        const data = JSON.parse(response.data);
        if (response.success) {
          getNotifications();
          toast.success(data.body);
          reset();
        }
        else {
          toast.error(data.body, { toastId: "error6" });
        }
      }
      handleClose();
      setApproving(false);
      setDeclining(false);
    } catch (error) {
      setApproving(false);
      setDeclining(false);
      toast.error(error);
      handleClose();
    }
  };

  useEffect(() => {
    fetchCompanyLogoDetails();
    fetchRequestCount();
    getNotifications();
  }, [])

  function logout() {
    nav("/logout");
  }
  if (location.pathname === constants.navigationLink.dashboardLink) {
    dashboard = true;
  }
  if (location.pathname === constants.navigationLink.companyProfile) {
    companyProfile = true;
  }
  if (location.pathname === constants.navigationLink.empProfile) {
    employeeProfile = true;
  }
  if (location.pathname === constants.navigationLink.employeeData) {
    employeeData = true;
  }
  if (location.pathname === constants.navigationLink.setting) {
    setting = true;
  }
  if (location.pathname === constants.navigationLink.changePassword) {
    setting = true;
  }
  if (location.pathname === constants.navigationLink.requestsAttendance) {
    requestsAttendance = true;
  }
  if (location.pathname === constants.navigationLink.broadcast || location.pathname === constants.navigationLink.createBroadCast || location.pathname === constants.navigationLink.detailBroadcast) {
    broadcast = true;
  }
  if (
    location.pathname === constants.navigationLink.manageLeaves ||
    location.pathname === constants.navigationLink.scheduleLeaves ||
    location.pathname === constants.navigationLink.scheduleHoliday
  ) {
    manageLeave = true;
  }
  if (location.pathname === constants.navigationLink.markAttendance) {
    markEmployeeAttendance = true;
  }

  function handleClickDeclined(notificationId, index) {
    setNotificationId(notificationId);
    setShow(true);
    setNotificationIndex(index);
    setApproveType(strings.declined)
  }

  function handleClickApproved(notificationId, index) {
    approveLeaveData.approveType = strings.approvedLabel;
    approveLeaveData.id = notificationId;
    approveLeaveData.reason = "";
    notificationPermission(approveLeaveData);
    setNotificationIndex(index);
    setApproving(true);
  }

  useEffect(() => {
    document.title = 'HourHive'
  }, []);

  useEffect(() => {
    const productTokenExist = localStorage.getItem('productToken');
    if (productTokenExist) {
      validateProductToken(productTokenExist)
    }
  }, [])

  const validateProductToken = async (productToken) => {
    try {

      const body = {
        productServiceToken: productToken
      }
      let response = await api.validateProductToken(body);
      if (response && response.data) {
        const data = JSON.parse(response.data);
        if(!response.success ){
            console.log("asdhasjd");
            
        }else{
           toast.error(data.body, { toastId: "error7" });
        }

      }
    } catch (error) {
      toast.error("Something went wrong", { toastId: "error7" });
    }
  }

  return (
    <>
   
    <>
    <Favicon url={companyLogo ? companyLogo : HourHiveLogo}/>
        <div className="layout">
        <div
          className={
            sidebar ? "w3-sidebar w3-bar-block" : "w3-sidebar sidebar-effect"
          }
        >
          {/* Use Navbar directly */}
          <Navbar display={'block'}/>
          <LogoutPopup
            show={modalShow}
            onHide={() => setModalShow(false)}
            logoutCall={logout}
          />
        </div>
          <div
            className={
              notificationToggle
                ? "notification-bar"
                : " notification-effect notification-bar"
            }
          >
            {notificationToggle ? <div className="close-icon-notification position-absolute" onClick={()=>close()}>
            <i className="ri-arrow-right-s-line"></i>
            </div> : null}
            
            <div className="all-notification-bar-fields">
            <h2 className="notification-label text-center">
            {strings.Component_Label}
            <button className={refreshNotification}><i className="ri-restart-line notification-refresh-icon" onClick={()=>{
              setRefreshNotification("notification-refresh-button-clicked");
              getNotifications();
            }}></i></button>
          </h2>
              <div
                className="accordion accordion-flush mt-2"
                id="accordionFlushExample"
              >
                <div
                  className={
                    isCollapsed
                      ? "accordion-item bg-transparent active-border"
                      : "accordion-item bg-transparent"
                  }
                >
                  <div
                    className="accordion-header d-flex justify-content-between align-items-center px-3"
                    id="flush-headingOne"
                    onClick={handleCollapseToggle}
                  >
                    <button
                      className="accordion-button collapsed bg-transparent "
                      type="button"
                    >
                      {strings.Leave_Request} {leaveCount && `(${leaveCount})`}
                    </button>
                    <i
                      className="fa-solid fa-chevron-up text-white"
                      id={
                        isCollapsed
                          ? "notification-arrow-inverse"
                          : "notification-arrow"
                      }
                    ></i>
                  </div>

                  <div
                    className={isCollapsed ? "" : "accordion-inner-body-scroll"}
                  >
                    {leaveNotifications
                      ? leaveNotifications.map((item, index) => {
                          return (
                            <div
                              id="flush-collapseOne"
                              className={`accordion-collapse collapse${
                                isCollapsed ? "" : " show"
                              }`}
                              aria-labelledby="flush-headingOne"
                              data-bs-parent="#accordionFlushExample"
                              key={index}
                            >
                              <div className="accordion-body">
                                <div className="request-one mb-3">
                                  <div className="row leave-request">
                                    <div >
                                      <h3>{item.name}</h3>
                                    </div>
                                   
                                    <div className="notification-container-label col-6 mt-2">
                                      {strings.reason}
                                    </div>
                                    <div className="notification-container-label col-6 mt-2">
                                      {strings.typeLabel}
                                    </div>
                                      <span className="notification-label-value col-6">
                                        {item.reason}
                                      </span> <span className="notification-label-value col-6">
                                        {item.key}
                                      </span><div>
                                      <div className="notification-container-label my-2">
                                        {strings.leaveSpan}
                                      </div>
                                       <div className="d-flex justify-content-between">
                                        <span className="notification-label-value">
                                          {moment(item.date[0]).format(
                                            "MMM, DD YYYY"
                                          )} {item.date.length > 1 ?"- "+moment(item.date[item.date.length - 1]).format("MMM, DD YYYY") : ""}
                                        </span>

                                        <span className="notification-label-value">
                                        
                                            {item.totalLeaveDays ? (item.totalLeaveDays===0.5 ? strings.halfDay :item.totalLeaveDays> 1 ? item.totalLeaveDays + strings.daysLabel : item.totalLeaveDays + strings.day):null}

                                        </span>
                                      </div>
                                    </div>

                                    <div className="d-flex justify-content-between col-12 my-2">
                                      <div>
                                        <i className="ri-time-line time-icon"></i>
                                        <p className="time">
                                          {moment(item.createdDate).format(
                                            "HH:mm"
                                          )}
                                        </p>
                                      </div>
                                      <div className="d-flex">
                                        <div>
                                          <button
                                            type="button"
                                            disabled={approving}
                                            className="decline-btn me-2"
                                            value={item._id}
                                            onClick={() => {
                                              handleClickDeclined(item._id ,index);
                                            }}
                                          >
                                            <Ripple duration={1000} />
                                            {strings.Decline_Btn}
                                          </button>
                                        </div>
                                        <div>
                                        {item.status && item.status.state===strings.approved ? null :
                                        <button
                                        type="button"
                                        className="approve-btn "
                                        value={item._id}
                                        disabled={approving || declining}
                                        onClick={() => {
                                          handleClickApproved(item._id,index);
                                          
                                        }}
                                          >
                                            <Ripple duration={1000} />
                                            {notificationIndex === index ? (
                                              approving ? (
                                                <SpinnerButtonMedium />
                                              ) : (
                                                strings.Approve_Btn
                                              )
                                            ) : (
                                              strings.Approve_Btn
                                            )}
                                          </button>}
                                        </div>
                                      </div>
                                    </div>
                                    {item.status ?
                                      <div>
                                        <div className="status-field">
                                        {strings.requestStatus}
                                    </div>
                                    {item.status.reason ?
                                      <div className="leave-approver-name hint hint--left" data-hint={item.status.reason ? item.status.reason :null}>
                                       <span> {item.status.approverName}</span> <span><img src={item.status.state ===strings.approved? Approved_Icon : Decline_Icon} alt="approve-icon" className="approve-icon"/></span>
                                    </div> :
                                    <div className="leave-approver-name" >
                                       <span> {item.status.approverName}</span> <span><img src={item.status.state ===strings.approved? Approved_Icon : Decline_Icon} alt="approve-icon" className="approve-icon"/></span>
                                    </div>
                                    }
                                    </div>:null}
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })
                      : noNotificationMsg}
                  </div>
                </div>
                <div
                  className={
                    isCollapsed2
                      ? "accordion-item bg-transparent active-border "
                      : "accordion-item bg-transparent"
                  }
                >
                  <div
                    className="accordion-header d-flex justify-content-between align-items-center px-3 "
                    id="flush-headingOne"
                    onClick={handleCollapseToggle2}
                  >
                    <button
                      className="accordion-button collapsed bg-transparent"
                      type="button"
                    >
                      {strings.Other_Notification}{" "}
                      {otherNotificationCount && `(${otherNotificationCount})`}
                    </button>
                    <i
                      className="fa-solid fa-chevron-up text-white"
                      id={
                        isCollapsed2
                          ? "notification-arrow-inverse"
                          : "notification-arrow "
                      }
                    ></i>
                  </div>
                  <div
                className={isCollapsed2 ? "" : "accordion-inner-body-scroll2"}
              >
                {otherNotification
                  ? otherNotification.map((item, index) => {
                      return (
                        <div
                          id="flush-collapseOne"
                          className={
                            isCollapsed2
                              ? "accordion-collapse  collapse-container"
                              : "accordion-collapse collapse-show"
                          }
                          key={index}
                          aria-labelledby="flush-headingOne"
                          data-bs-parent="#accordionFlushExample "
                        >
                          <div className="accordion-body">
                            <div className="request-one">
                              <div className="row leave-request">
                                <div >
                                  <h3>{item.name}</h3>
                                </div>                                
                                <div className="notification-container-label col-6 mt-2">
                                  {strings.reason}
                                </div>
                                <div className="notification-container-label col-6 mt-2">
                                {strings.typeLabel}
                                </div>
                                 <span className="notification-label-value col-6">
                                    {item.reason}
                                  </span>
                                  <span className="notification-label-value col-6">
                                    {item.type}
                                  </span>
                                   <div>
                                  <div className="notification-container-label my-2">
                                    {strings.leave_span}
                                  </div>
                                  <div className="d-flex justify-content-between">
                                    <span className="notification-label-value">
                                      {moment(item.date[0]).format(
                                        "MMM, DD YYYY"
                                      )} {item.date.length > 1 ?"- "+moment(item.date[item.date.length - 1]).format("MMM, DD YYYY") : ""}
                                    </span>

                                    <span className="notification-label-value">
                                    {item.totalLeaveDays ? (item.totalLeaveDays===0.5 ? strings.halfDay :item.totalLeaveDays> 1 ? item.totalLeaveDays + strings.daysLabel : item.totalLeaveDays + strings.day):null}
                                    </span>
                                  </div>
                                </div>

                                <div className="d-flex justify-content-between my-2">
                                  <div className="">
                                    <i className="ri-time-line time-icon"></i>
                                    <p className="time">
                                      {moment(item.createdDate).format("HH:mm")}
                                    </p>
                                  </div>
                                  <div className="d-flex">
                                    <div>
                                    <button
                                        type="button"
                                        disabled={approving}
                                        className="decline-btn me-2"
                                        value={item._id}
                                        onClick={() => {
                                          handleClickDeclined(item._id,index)
                                        }}
                                      >
                                        <Ripple duration={1000} />
                                        {strings.Decline_Btn}
                                      </button>
                                    </div>
                                    {item.status && item.status.state===strings.approved ? null :<div>
                                        <button
                                        type="button"
                                        className="approve-btn "
                                        value={item._id}
                                        disabled={approving || declining}
                                        onClick={() => {
                                          handleClickApproved(item._id,index)
                                        }}
                                      >
                                        <Ripple duration={1000} />
                                        {notificationIndex === index ? (
                                          approving ? (
                                            <SpinnerButtonMedium />
                                          ) : (
                                            strings.Approve_Btn
                                          )
                                        ) : (
                                          strings.Approve_Btn
                                        )}
                                      </button>
                                    </div>}
                                  </div>
                                </div>
                                {item.status ?
                                      <div>
                                        <div className="status-field">
                                        {strings.requestStatus}
                                    </div>
                                    {item.status.reason ?
                                      <div className="leave-approver-name hint hint--left" data-hint={item.status.reason ? item.status.reason :null}>
                                       <span> {item.status.approverName}</span> <span><img src={item.status.state ===strings.approved? Approved_Icon : Decline_Icon} alt="approve-icon" className="approve-icon"/></span>
                                    </div> :
                                    <div className="leave-approver-name" >
                                       <span> {item.status.approverName}</span> <span><img src={item.status.state ===strings.approved? Approved_Icon : Decline_Icon} alt="approve-icon" className="approve-icon"/></span>
                                    </div>
                                    }
                                    </div>:null}
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })
                  : noNotificationMsg}
              </div>
                </div>
                <div
                  id="flush-collapseOne"
                  className={`accordion-collapse collapse${
                    isCollapsed ? "" : " show"
                  }`}
                  aria-labelledby="flush-headingOne"
                  data-bs-parent="#accordionFlushExample"
                ></div>
              </div>
            </div>
          </div>
          <div
            className={
              sidebar || notificationToggle ? "dark-effect" : "light-effect"
            }
          >
            <div className="layout-changes">
              <div className="side-nav-bar">
                <Navbar />
              </div>
              <div >
                <div className="page-with-notification">
                <div
                      className="side-navbar-button"
                      onClick={() => {
                        setSidebar(true);
                        setNotificationToggle(false);
                      }}
                    >
                      <img src={companyLogo} /> 
                    </div>
                <h6 className="page-name-company">
                  {dashboard ? strings.dashboard : null}
                  {broadcast ? strings.broadcast : null}
                  {setting ? strings.setting : null}
                  {manageLeave ? strings.manageLeave : null}
                  {requestsAttendance ? strings.attendanceRequest : null}
                  {companyProfile || employeeProfile || employeeData
                    ? strings.profile
                    : ""}
                </h6>
                 <div
                      className="side-notification-bar"
                      onClick={() => {
                        setNotificationToggle(true);
                        setSidebar(false);
                      }}
                    >
                      <i className="ri-notification-line"></i> 
                      {totalCount> 0 ?  <span className="position-absolute count-variable-notification">{totalCount}</span> : null}
                     
                    </div>
                    </div>
                <div className="main-layout">
                  <div
                    onClick={() => {
                      close();
                    }}
                  >
                    <Outlet />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      <Modal
        show={show}
        onHide={handleClose}
        className="notification-popup"
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header>
          <Modal.Title>{strings.reason}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit(notificationPermission)}>
            <textarea
              {...register("leaveDeclineReason", {
                required: {
                  value: true,
                  message: strings.requiredLabel,
                },
                maxLength: {
                  value: 200,
                  message: strings.maxLength,
                },
                minLength: {
                  value: 10,
                  message: strings.minLength,
                },
                pattern : {
                  value : constants.inputPattern.patternWithoutSpaceThird,
                  message : strings.extraSpace
                }
              })}
              name="leaveDeclineReason"
              className={
                errors.leaveDeclineReason
                  ? "error-border-active"
                  : "error-border"
              }
              rows="4"
              id="password"
              placeholder=" "
            />
            <div className="form-validation">
              <small>
                {errors.leaveDeclineReason && (
                  <span className="position-absolute text-danger">
                    <strong className="me-1 ">
                      <i className="ri-error-warning-line error-icon-reason"></i>
                    </strong>
                    {errors.leaveDeclineReason.message}
                  </span>
                )}
              </small>
            </div>
            <div className="decline-reason-button mt-4">
              <button
                className="cancel-reason-btn"
                disabled={declining}
                onClick={handleClose}
                type="reset"
              >
                <Ripple duration={1000} />
                {strings.cancel}
              </button>
              <button
                type="submit"
                className="submit-reason-btn"
                disabled={declining}
              >
                <Ripple duration={1000} />
                {declining ? <SpinnerButtonMedium /> : strings.submit}
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>

    </>
  );
}
